import { TileProps } from "@app/shared/interfaces/dashboard";
import * as React from "react";
import { Link } from "react-router-dom";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import { BreadcrumbTemplateEnum } from "@app/shared/breadcrumbs/breadcrumbTemplates";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";

const tiles: TileProps[] = [
  {
    allowedRoles: [Roles.PERFORMANCE_MONITOR],
    icon: QesIcons.BarChartV7,
    route: "ui-statistics",
    title: "UI Statistics"
  },
  {
    allowedRoles: [Roles.PERFORMANCE_MONITOR],
    icon: QesIcons.TerminalBrowser,
    route: "job-statistics",
    title: "Job Statistics"
  },
];

export const PerformanceDashboard: React.FC<React.PropsWithChildren<unknown>> = () => {

  return (
    <Page documentTitle="Performance Dashboard">
      <Breadcrumbs template={BreadcrumbTemplateEnum.Performance} items={[]}
      />
      <PageInner>
        <PageHeader iconName={QesIcons.RocketV2} title="Performance Dashboard" disableHR={false} />
        <PageSection>
          <div className="container mt-3">
            {tiles.map((tile) => <Tile key={tile.title} icon={tile.icon} route={tile.route} title={tile.title} allowedRoles={tile.allowedRoles} />)}
          </div>
        </PageSection>
      </PageInner>
    </Page>
  );
};

const Tile: React.FC<React.PropsWithChildren<TileProps>> = ({ icon, route = "#", title, allowedRoles }) => {
  return (
    <RoleRestricted allowedRoles={allowedRoles}>
      <Link to={`/performance/${route}`} className="dashboard-tile col-4">
        {icon ? <QesIcon iconName={icon} width="27" height="27" className="mb-2" isDecorative={true} /> : null}
        <h6>{title}</h6>
      </Link>
    </RoleRestricted>
  );
};
